import { Legend } from '@/models/Legend'

export const filterLegendList = (legends: Legend[], filterList: string[]): Legend[] =>
  legends.filter(legend => filterList.includes(legend.Type))
